import React, { useEffect, useSyncExternalStore } from 'react';
import { useStateSelector } from '../../store/selectors';
import { maintenanceMode } from '../../utils/maintenanceMode';
import { reloadPage } from '../../utils/reloadPage';
import './MaintenanceOverlay.scss';

export const HEALTH_POLL_INTERVAL_MS = 15000;

// Full-screen overlay shown when the API is unreachable (prod deploy in
// progress). Polls the anonymous health endpoint and reloads the page once
// the server is back — the reload also picks up a freshly deployed bundle.
export const MaintenanceOverlay = () => {
    const isServerUnavailable = useSyncExternalStore(
        maintenanceMode.subscribe,
        maintenanceMode.isServerUnavailable
    );
    const axios = useStateSelector((state) => state.core.axios);

    useEffect(() => {
        if (!isServerUnavailable || !axios) {
            return;
        }
        let isActive = true;
        const checkHealth = () => {
            axios
                .get('/api/health', { skipMaintenanceCheck: true })
                .then((response: any) => {
                    if (isActive && response && response.status === 200) {
                        reloadPage();
                    }
                })
                .catch(() => {
                    // Still down — keep polling.
                });
        };
        checkHealth();
        const intervalId = setInterval(checkHealth, HEALTH_POLL_INTERVAL_MS);
        return () => {
            isActive = false;
            clearInterval(intervalId);
        };
    }, [isServerUnavailable, axios]);

    if (!isServerUnavailable) {
        return null;
    }

    return (
        <div className="maintenance-overlay">
            <div className="maintenance-overlay__content">
                <div className="maintenance-overlay__dots">
                    <span />
                    <span />
                    <span />
                </div>
                <h2>We&rsquo;ll be right back</h2>
                <p>
                    VetValue is temporarily down for maintenance. This page
                    will refresh automatically as soon as we&rsquo;re back
                    online.
                </p>
            </div>
        </div>
    );
};
